<template>
  <div v-if="selectionData" class="flex h-full">
    <div id="sideBar" class="w-2/10 1.5xl:w-1/6 max-h-inherit h-inherit"
         :class="{'hidden':activeProduct || activeDecor}">
      <div class="h-1/10 flex items-center mb-4">
        <button
          class="title classen__rounded_full hover__button bg-white w-9/10 border-classen__primary border-2 mt-1 text-lg"
          @click="confirmClose">
          <p class="leading-none">
            <i class="fas fa-angle-left"></i> {{ getTranslation('back') }}
          </p>
        </button>
      </div>
      <div v-if="openedTab===0">
        <p class="font-bold text-lg mt-1">{{ getTranslation('currentSelection') }}:</p>
        <p>{{ selectionData.name }}</p>
        <img :src="selectionData.logo" alt="logo" class="w-1/2"/>
      </div>
    </div>
    <div v-if="isLoaded" id="content" class="max-h-inherit w-9/10"
         :class="{'hidden':activeProduct || activeDecor}">
      <div id="content_topBar" class="text-xl grid grid-rows-2 items-end h-1/10 mb-4">
        <div class="tabs flex">
          <p :class="{'border-b-4 border-classen__primary':openedTab === 0}"
             class="cursor-pointer"
             @click="openedTab = 0">
            {{ getTranslation('selection') }} ({{
              selectionData.selectionList.data.length
            }}/{{ total }})
          </p>
          <p class="ml-3 cursor-pointer"
             :class="{'border-b-4 border-classen__primary':openedTab === 1}"
             @click="openedTab = 1">
            {{ getTranslation('furtherInformation') }}
          </p>
        </div>
        <input v-if="openedTab===0" v-model="searchInput" type="text"
               :placeholder="getTranslation('search')"
               class="border-shadow rounded-20 search float-left mt-2 mb-2 pl-2 row-start-2">
        <div class="col-start-5 row-start-1 flex justify-end items-end h-1/10">
          <label
            :class="{'text-green-600': this.statusCode === 200, 'text-red-600': this.statusCode === 400}">
            {{ statusMessage }}
          </label>
          <button @click="confirmClose"
                  class="action_item col-span-2 cancel border border-classen__primary text-center btn_hover">
            <p class="leading-none">{{ getTranslation('cancel') }}</p>
          </button>
          <button @click="saveSelection()"
                  :disabled="nameExists"
                  :class="{'cursor-not-allowed':nameExists, 'cursor-pointer':!nameExists}"
                  class="action_item col-span-3 save text-center btn_hover text-white">
            <p class="leading-none">{{ getTranslation('save') }}</p>
          </button>
          <div v-if="allowDelete"
               @click="deleteSelection"
               class="cursor-pointer action_item text-white flex justify-center items-center buttonWithTooltip">
              <div><i class="fas fa-trash labelBeforeSpanTrash"></i></div>
            <span class="tooltipText">{{ getTranslation('delete') }}</span>
          </div>
          <!-- Todo: Re-enable -->
          <div v-if="false && displayedActions && actionPermissions.embed"
               class="cursor-pointer action_item text-white flex justify-center items-center ">
            <img src="../../../assets/icons/pijltjes.svg" alt="pijltjes">
          </div>
          <div @click="isRequestVisible=true"
               v-if="displayedActions && actionPermissions.requestHRImages && false"
               class="cursor-pointer action_item text-white flex justify-center items-center buttonWithTooltip">
            <img src="../../../assets/icons/image.svg" alt="image">
            <span class="tooltipText">{{ getTranslation('requestHRImages') }}</span>
          </div>
          <div @click="isGenerateLinkVisible=true"
               v-if="displayedActions && actionPermissions.generateSharedLink"
               class="cursor-pointer action_item text-white flex justify-center items-center buttonWithTooltip">
            <img src="../../../assets/icons/export.svg" alt="export">
            <span class="tooltipText">{{ getTranslation('generateLink') }}</span>
          </div>
          <div v-if="displayedActions && actionPermissions.generateExcelFile"
               class="cursor-pointer action_item text-white flex justify-center items-center buttonWithTooltip"
               @click="isPopupGenerateExcelVisible = true">
            <img src="../../../assets/icons/excel.svg" alt="excel">
            <span class="tooltipText">{{ getTranslation('generateExcel') }}</span>
          </div>
          <div v-if="displayedActions && actionPermissions.generatePdf"
               @click="isPopupGenerateVisible = true"
               class="cursor-pointer action_item text-white flex justify-center items-center buttonWithTooltip">
            <img src="../../../assets/icons/pdf.svg" alt="pdf">
            <span class="tooltipText">{{ getTranslation('generatePdf') }}</span>
          </div>
          <div @click="displayedActions = !displayedActions"
               class="action_item text-white flex justify-center items-center buttonWithTooltip">
            <label v-show="!displayedActions"><i class="fas fa-bars labelBeforeSpanList"></i></label>
            <label v-show="displayedActions"><i class="fas fa-times labelBeforeSpanClose"></i></label>
            <span v-show="displayedActions" class="tooltipText tooltipForCloseButton">{{ getTranslation('close') }}</span>
          </div>
        </div>
        <c-sort :title="getTranslation('sortBy')" @updateSelected="updateSelected"
                :items="filters" :selectedItem="selectedSort"
                v-if="openedTab === 0"
                class="col-start-5 row-start-2 w-1/2 justify-self-end"></c-sort>
      </div>

      <div v-show="openedTab===0" class="h-full w-full">
        <div id="content_bottomBar_items"
             class="h-9/10 h-full overflow-y-auto grid grid-cols-2 1.2xl:grid-cols-3 1.6xl:grid-cols-4 1.9xl:grid-cols-5 2.3xl:grid-cols-6 2.7xl:grid-cols-7 3.1xl:grid-cols-8 3.1xl:grid-cols-9 4k:grid-cols-10 pb-8">
          <div v-show="isLoaded" v-for="(item, index) in filteredItems" class="h-auto">
            <c-product-view :key="index" @delete="deleteItem(item)" :displayDelete="allowEdit"
                            v-if="getType(item.type) === 'Product'" :product="item.item"
                            :display-quick="false" :selected-selection="null"/>
            <c-decor-view :key="index" @delete="deleteItem(item)" :displayDelete="allowEdit"
                          v-if="getType(item.type) === 'Decor'" :decor="item.item"
                          :display-quick="false" :selected-selection="null"/>
          </div>
          <div class="load_more_div w-full h-1/20 flex mt-5 align-center justify-center">
            <button v-if="hasMore"
                    class="mt-2 classen__button justify-self-center self-center col"
                    :class="{'hover__button':!isLoadingNextProducts}"
                    @click="loadNextPage">
              <label v-if="!isLoadingNextProducts">{{ getTranslation('loadMoreItems') }}</label>
              <c-loader v-if="isLoadingNextProducts" :inline="true" :bg-blur="false"
                        class="transform scale-50"></c-loader>
            </button>
          </div>
        </div>
      </div>

      <div v-if="openedTab===1" id="content_bottomBar_info"
           class="h-9/10 text-xl overflow-y-auto fhd:w-4/5 1.5xl:w-3/4 pr-10">
        <div class="grid colsDef border-b-2 border-classen__secondary info_item">
          <label>{{ getTranslation('selectionCreator') }}:</label>
          <label class="font-bold">{{ selectionData.owner.name }}</label>
        </div>
        <div class="grid colsDef border-b-2 border-classen__secondary info_item">
          <label>{{ getTranslation('selectionName') }}:</label>
          <label v-if="!allowEdit" class="font-bold">{{ selectionData.name }}</label>
          <input v-else type="text"
                 :class="{'border border-red-600 ': nameExists}"
                 class="input"
                 v-model="selectionData.name"/>
        </div>

        <div class="grid colsDef border-b-2 border-classen__secondary info_item">
          <label>{{ getTranslation('selectionType') }}:</label>
          <label v-if="!allowEditType" class="font-bold">{{ selectionData.type }}</label>
          <select v-else v-model="selectionData.type"
                  :disabled="isChangeTypeDisabled"
                  class="input">
            <option value="public">Public</option>
            <option value="private">Private</option>
            <option value="client">Client</option>
          </select>
        </div>

        <div class="grid colsDef border-b-2 border-classen__secondary logo_info_item">
          <label>{{ getTranslation('logo') }}:</label>
          <label v-if="!allowEdit" class="font-bold">
            <img v-if="selectionData.logo !== '' && selectionData.logo !== null"
                 :src="selectionData.logo"
                 class="logo_preview" alt="logo_preview"/>
          </label>
          <div v-else>
            <img v-if="selectionData.logo !== '' && selectionData.logo !== null"
                 :src="selectionData.logo"
                 class="logoImg" alt="logo image"/>
            <div class="actions">
              <input disabled type="text" class="logo input" v-model="selectionData.logo"/>
              <button @click="importData" class="upload text-white"><i class="fas fa-upload"></i>
              </button>
              <button @click="selectionData.logo = null"
                      class="ml-1 upload trashLogo text-white">
                <i class="fas fa-trash"></i></button>
            </div>
          </div>
        </div>

        <div v-if="allowEdit"
             class="grid colsDef pt-4 border-b-2 border-classen__secondary info_item_selections">
          <label>{{ getTranslation('sharedWith') }}:</label>
          <div v-if="isLoaded">
            <c-custom-region-dropdown :disabled="!sharePermissions.regions"
                                      :selected-regions.sync="selectedRegions"
                                      :regions="regions"
                                      @selectAll="selectAll"
                                      :title="getTranslation('regions')"/>
            <c-custom-user-dropdown :disabled="!sharePermissions.regionalAdmins"
                                    :users="regionalUsers"
                                    :title="getTranslation('regionalAdmins')"/>
            <c-custom-user-dropdown :disabled="!sharePermissions.salesAdmins"
                                    :users="salesAdmins"
                                    :title="getTranslation('salesAdmins')"/>
            <c-custom-user-dropdown :disabled="!sharePermissions.flexible"
                                    :users="flexibleUsers"
                                    :title="getTranslation('flexibleUsers')"/>
          </div>
        </div>
      </div>
    </div>

    <c-product-detail id="prod_detail" class="h-full" @close="closeProduct"
                      :product="activeProduct" v-if="activeProduct"
                      :active-selection="noSelection"/>
    <c-decor-detail id="dec_detail" class="h-full" @close="closeDecor"
                    :active-selection="noSelection" :decor="activeDecor" v-if="activeDecor"/>

    <c-hr-image @close="isRequestVisible=false" v-if="isRequestVisible"
                :products="allSelectionProducts"
                :selection="selectionData"/>

    <c-generate-link-popup v-if="isGenerateLinkVisible" :selection="selectionData"
                           @cancel="isGenerateLinkVisible = false"/>

    <c-loader v-if="!isLoaded"></c-loader>

    <c-confirm-popup
      v-if="isPopupConfirmVisible"
      :phrase="getTranslation('areYouSureYouWantToDeleteThis')"
      :confirm-text="getTranslation('yesDeleteSelection')"
      :cacnel-text="getTranslation('cancel')"
      @confirm="onConfirm"
      @cancel="onCancel"
    />

    <c-confirm-popup
      v-if="isPopupConfirmCancelVisible"
      :phrase="getTranslation('doYouWantToSaveBeforeLeaving')"
      :confirmText="getTranslation('yesSave')"
      :cancelText="getTranslation('no')"
      :showCloseButton="true"
      @confirm="saveSelection(true)"
      @cancel="closeSelection"
    />

    <c-generate-excel-popup v-if="isPopupGenerateExcelVisible" :selection="selectionData"
                            @cancel="isPopupGenerateExcelVisible = false"/>

    <c-generate-pdf-popup v-if="isPopupGenerateVisible" @onClose="isPopupGenerateVisible = false"
                          :selection="selectionData"/>
  </div>
</template>

<script>

import Vue from "vue";
import getTranslation from "../../../mixins/getTranslation";
import ProductView from "../Products/ProductView";
import DecorView from "../Decors/DecorView";
import CustomUserDropdown from "../CustomUserDropdown";
import CustomRegionDropdown from "../CustomRegionDropdown";
import SortingDropdown from "../SortingDropdown";
import ProductDetail from "../Products/ProductDetail";
import DecorDetail from "../Decors/DecorDetail";
import EventBus from "../../../services/EventBus";
import Loader from "../../Loader";
import HRImagePopup from "./actions/HrRequest/HRImagePopup";
import getPermissions from "../../../mixins/getPermissions";
import ConfirmationPopup from "../../form/ConfirmationPopup";
import GenerateExcelPopup from "./GenerateExcelPopup";
import GeneratePdfPopup from "./actions/GeneratePdf/GeneratePdfPopup";
import GenerateLinkInformation from "./GenerateLinkInformation";
import GenerateLink from "./GenerateLink";

export default {
  name: "ViewSelection",

  mixins: [getTranslation, getPermissions],

  components: {
    'c-product-view': ProductView,
    'c-hr-image': HRImagePopup,
    'c-decor-view': DecorView,
    'c-custom-user-dropdown': CustomUserDropdown,
    'c-custom-region-dropdown': CustomRegionDropdown,
    'c-sort': SortingDropdown,
    'c-product-detail': ProductDetail,
    'c-decor-detail': DecorDetail,
    'c-loader': Loader,
    'c-confirm-popup': ConfirmationPopup,
    'c-generate-excel-popup': GenerateExcelPopup,
    'c-generate-pdf-popup': GeneratePdfPopup,
    'c-generate-link-popup': GenerateLinkInformation,
    'c-generate-link': GenerateLink,
  },

  props: {
    selection: {required: true, type: Object},
    allowEdit: {required: false, type: Boolean, default: true},
    allowEditType: {required: false, type: Boolean, default: true},
    allowDelete: {required: true, type: Boolean},
    sharePermissions: {required: true, type: Object},
    actionPermissions: {required: true, type: Object},
  },

  data() {
    return {
      page: 1,
      lastPage: 100,
      total: 0,
      isPopupConfirmVisible: false,
      isPopupConfirmCancelVisible: false,
      isLoadingNextProducts: false,
      isPopupGenerateExcelVisible: false,
      isPopupGenerateVisible: false,
      isGenerateLinkVisible: false,
      noSelection: {id: -1, name: 'Set default selection'},
      searchInput: '',
      selectionData: null,
      openedTab: 0,
      displayedActions: false,
      isLoaded: false,
      selectedRegionals: [],
      selectedSales: [],
      selectedFlexibles: [],
      selectedRegions: [],
      activeProduct: null,
      activeDecor: null,
      itemsToDelete: [],
      selected: null,
      isRequestVisible: false,
      statusMessage: "",
      statusCode: "",
      file: null,
      changesMade: false,
      regionsCopy: [],
    }
  },

  created() {
    this.getSelectionData();

    EventBus.listen('set-active_product', this.setActiveProduct)
    EventBus.listen('set-active_decor', this.setActiveDecor)
  },

  destroyed() {
    EventBus.destroy('set-active_product', this.setActiveProduct)
    EventBus.destroy('set-active_decor', this.setActiveDecor)
  },

  computed: {
    filters() {
      return [
        {value: 'externalId', direction: 'desc', text: this.getTranslation('newToOld')},
        {value: 'articleName', direction: 'asc', text: this.getTranslation('name')},
        {value: 'articleNumber', direction: 'desc', text: this.getTranslation('articleNumber')},
        {value: 'range', direction: 'asc', text: this.getTranslation('range')},
        {value: 'categoryName', direction: 'asc', text: this.getTranslation('category')},
      ];
    },

    selectedSort() {
      return {value: 'externalId', direction: 'desc', text: this.getTranslation('newToOld')};
    },

    hasMore() {
      return this.page < this.lastPage;
    },

    nameExists() {
      let found = this.selections.find((sel) => {
        return this.selectionData.name === sel.name && this.selectionData.id !== sel.id;
      })

      if (found !== undefined) {
        this.statusCode = 400;
        this.statusMessage = "Name must be unique";
      } else {
        this.statusCode = "";
        this.statusMessage = "";
      }

      return found !== undefined
    },

    selections() {
      let selections = this.$dashboardStore.getters.getSelections;
      if (this.activeUserHasRole(this.ROLES.SALES_ADMIN)) {
        selections = selections.filter((selection) => selection.type !== 'public');
      }
      return selections;
    },

    activeUser() {
      return this.$dashboardStore.getters.getActiveUser();
    },

    allSelectionProducts() {
      let products = [];
      this.selectionData.selectionList.data.forEach((item) => {
        if (this.getType(item.type) === 'Decor') {
          return;
        }
        products.push(item.item)
      });

      return products
    },

    users() {
      return this.$dashboardStore.getters.getUsers
    },

    usersForRegions() {
      let users = [];
      this.selectedRegions.forEach((region) => {
        region.users.forEach((user) => {
          let u = users.find((searchUser) => {
            return searchUser.id === user.id
          })
          if (!u) {
            this.$set(user, 'selected', this.checkIfSharedWith(user))
            users.push(user)
          }
        })
      })

      return users
    },

    regions() {
      let regions = this.regionsCopy
      let users = this.selectionData.sharedWith
      if (!users && !regions) {
        return []
      }

      return regions
    },

    regionalUsers() {
      let regionalUsers = this.usersForRegions.filter((user) => {
        return user.permissions.role === this.ROLES.REGIONAL_ADMIN.value;
      });

      if (this.activeUserHasRole(this.ROLES.SALES_ADMIN)) {
        regionalUsers.forEach((user) => {
          user.selected = true;
          return user;
        })
      }

      return regionalUsers;
    },

    salesAdmins() {
      return this.usersForRegions.filter((user) => {
        return user.permissions.role === this.ROLES.SALES_ADMIN.value;
      });
    },

    flexibleUsers() {
      return this.usersForRegions.filter((user) => {
        return user.permissions.role === this.ROLES.FLEXIBLE.value;
      });
    },

    selectedUsers() {
      return this.usersForRegions.filter((user) => {
        return user.selected === true
      })
    },

    filteredItems() {
      if (!this.selectionData) {
        return []
      }

      let items = this.selectionData.selectionList.data.filter((item) => {
          return item.item ? item.item.name.toLowerCase().includes(this.searchInput.toLowerCase()) : false;
      })

      let products = [];
      let decors = [];

      items.forEach((item) => {
        if (this.getType(item.type) === 'Product') {
          products.push(item);
          return
        }

        decors.push(item)
      })

      let sortingMethod = this.selectedSort.value;

      let sortingMapping = {
        externalId: this.sortExternalId(products, decors),
        articleNumber: this.sortExternalId(products, decors),
        articleName: this.sortArticleName(products, decors),
        collectionName: this.sortCollectionName(products, decors),
        range: this.sortRange(products, decors),
        categoryName: this.sortCategoryName(products, decors),
      }

      return sortingMapping[sortingMethod];
    },

    isChangeTypeDisabled() {
      return this.activeUserHasRole(this.ROLES.SALES_ADMIN) && this.activeUser.id !== this.selectionData.owner.id
    }
  },

  watch: {
    selectionData: {
      handler() {
        this.changesMade = true;
      },
      deep: true
    },

    selectedUsers() {
      this.changesMade = true;
    },

    itemsToDelete() {
      this.changesMade = true;
    }
  },

  methods: {
    loadNextPage() {
      if (this.isLoadingNextProducts) {
        return
      }

      this.isLoadingNextProducts = true;
      this.page++;
      this.$dashboardStore.dispatch('getSelectionItems', {
        selectionId: this.selection.id,
        page: this.page
      })
        .then((res) => {
          Vue.set(this.selectionData.selectionList, 'data', [...this.selectionData.selectionList.data, ...res.data]);
          this.itemsToDelete = [];
          this.isLoadingNextProducts = false;
        })
    },

    setRegions() {
      this.regionsCopy = JSON.parse(JSON.stringify(this.$dashboardStore.getters.getRegions))

      this.selectedRegions = [];

      this.selectedRegions = [];
      this.selectionData.sharedWith.forEach((sharedWith) => {
        sharedWith.regions.forEach((region) => {
          let fullRegion = this.regions.find((reg) => reg.id === region.id)
          fullRegion.selected = true;
          let isNotInSelectedRegions = this.selectedRegions.find((reg) => reg.id === region.id) === undefined
          if (isNotInSelectedRegions) {
            this.selectedRegions.push(fullRegion)
          }
        })
      })
    },

    selectAll(val) {
      this.selectedRegions = []
      if (val) {
        this.regions.forEach((region) => {
          this.$set(region, 'selected', true)
          this.selectedRegions.push(region)
        })
      } else {
        this.regions.forEach((region) => {
          this.$set(region, 'selected', false)
        })
      }
    },

    deleteSelection() {
      this.isPopupConfirmVisible = true;
    },

    onCancel() {
      this.isPopupConfirmVisible = false;
    },

    onConfirm() {
      this.isLoaded = false;
      this.$dashboardStore.dispatch('deleteSelection', this.selection.id)
        .then((res) => {
          if (res.response !== 'success') {
            return
          }
          this.$dashboardStore.dispatch('forceReloadSelections');
          this.isLoaded = true;
          this.isPopupConfirmVisible = false;
          this.$emit('onClose');
        })
    },

    sortExternalId(products, decors) {
      products.sort((a, b) => {
        return a.item.externalId - b.item.externalId
      });
      decors.sort((a, b) => {
        return a.item.externalId - b.item.externalId
      });

      return [...products, ...decors]
    },

    sortArticleName(products, decors) {
      products.sort((a, b) => {
        return a.item.name.localeCompare(b.item.name)
      })
      decors.sort((a, b) => {
        return a.item.name.localeCompare(b.item.name)
      });

      return [...products, ...decors]
    },

    sortCollectionName(products, decors) {
      products.sort((a, b) => {
        return a.item.collectionName.localeCompare(b.item.collectionName)
      })
      decors.sort((a, b) => {
        return a.item.name.localeCompare(b.item.name)
      });

      return [...products, ...decors]
    },

    sortRange(products, decors) {
      products.sort((a, b) => {
        return a.item.rangeName.localeCompare(b.item.rangeName)
      })
      decors.sort((a, b) => {
        return a.item.name.localeCompare(b.item.name)
      });

      return [...products, ...decors]
    },

    sortCategoryName(products, decors) {
      products.sort((a, b) => {
        return a.item.categoryName.localeCompare(b.item.categoryName)
      })
      decors.sort((a, b) => {
        return a.item.name.localeCompare(b.item.name)
      });

      return [...products, ...decors]
    },

    updateSelected(val) {
      this.selectedSort = val;
    },

    importData() {
      let input = document.createElement('input');
      input.type = 'file';
      input.accept = ".png, .jpg, .jpeg, .pdf";
      input.onchange = (_) => {
        // you can use this method to get file and perform respective operations
        let formData = new FormData();

        formData.append("file", Array.from(input.files)[0]);
        this.$dashboardStore.dispatch('uploadSelectionLogo', formData)
          .then((res) => {
            this.selectionData.logo = res.path
          })
      };
      input.click();
    },

    getSelectionData() {
      this.isLoaded = false;
      this.$dashboardStore.dispatch('getSelection', this.selection.id)
        .then((res) => {
          this.selectionData = res.data;
          this.itemsToDelete = [];
          this.setRegions();
          this.$dashboardStore.dispatch('getSelectionItems', {
            selectionId: this.selection.id,
            page: this.page
          })
            .then((res) => {
              let data = {data: res.data};
              Vue.set(this.selectionData, 'selectionList', data);
              this.itemsToDelete = [];
              this.lastPage = res.meta.last_page;
              this.total = res.meta.total;
              this.isLoaded = true;
            })
        })
    },

    deleteItem(item) {
      this.itemsToDelete.push(item);

      this.selectionData.selectionList.data = this.selectionData.selectionList.data.filter((it) => {
        return it.id !== item.id
      })
    },

    getType(type) {
      return type.split('\\')[2]
    },

    checkIfSharedWith(user) {
      let userShare = this.selectionData.sharedWith.find((sharedUser) => {
        return sharedUser.id === user.id
      })

      return userShare !== undefined;
    },

    closeProduct() {
      this.activeProduct = null
      this.displayDecor();
    },

    closeDecor() {
      this.activeDecor = null
      this.displayProduct();
    },

    closePackaging() {
      this.activePackaging = null
    },

    setActiveProduct(val) {
      this.displayProduct()

      this.activeProduct = val
    },

    setActiveDecor(val) {
      this.displayDecor();

      this.activeDecor = val
    },

    displayProduct() {
      let decor = document.getElementById('dec_detail');
      if (decor) {
        decor.style.setProperty("display", "none")
      }

      let product = document.getElementById('prod_detail');
      if (product) {
        product.style.setProperty("display", "block")
      }
    },

    displayDecor() {
      let product = document.getElementById('prod_detail');
      if (product) {
        product.style.setProperty("display", "none")
      }

      let decor = document.getElementById('dec_detail');
      if (decor) {
        decor.style.setProperty("display", "block")
      }
    },

    saveSelection(close = false) {
      if (this.nameExists) {
        this.isPopupConfirmCancelVisible = false;
        return;
      }

      let selectionDataCopy = JSON.parse(JSON.stringify(this.selectionData))
      selectionDataCopy.sharedWith = this.selectedUsers;

      let promises = []
      let prom1 = this.$dashboardStore.dispatch('updateSelection', selectionDataCopy)
      promises.push(prom1);

      this.itemsToDelete.forEach((item) => {
        promises.push(this.$dashboardStore.dispatch('deleteSelectionItem', item.id));
      })

      Promise.all(promises)
        .then((res) => {
          this.statusMessage = "Saved";
          this.statusCode = 200;
          setTimeout(this.clearStatus, 3000)
          this.$dashboardStore.dispatch('forceReloadSelections');
          this.changesMade = false;
          this.selection.isNew = false;
          if (close) {
            this.$emit('onClose')
          }
        })
        .catch((e) => {
          this.statusMessage = "Could not save";
          this.statusCode = "400";
          setTimeout(this.clearStatus, 3000)
        })
    },

    clearStatus() {
      this.statusMessage = "";
      this.statusCode = 0;
    },

    confirmClose() {
      if (this.selection.isNew) {
        this.isPopupConfirmVisible = true;
        return;
      }

      if (this.changesMade) {
        this.isPopupConfirmCancelVisible = true
        return
      }

      this.closeSelection();
    },

    closeSelection() {
      if (this.nameExists) {
        this.isPopupConfirmCancelVisible = false;
        return;
      }

      this.changesMade = false;
      this.$emit('onClose')
    }
  }
}
</script>

<style scoped>
.search {
  width: 200px
}

.info_item {
  height: 70px;
  line-height: 70px;
}

.logo_info_item {
  /*max-height: 160px;*/
  line-height: 70px;
  padding: 1fr 0 1fr 0;
}

.info_item_selections {
  height: fit-content;
}

#sideBar, #content {
  height: inherit !important;
}

.action_item {
  height: 40px;
  width: 40px;
  border-radius: 20px;
  background-color: var(--primary);
  line-height: 40px;
  margin-left: 5px;
}

.cancel {
  background-color: white;
  color: var(--primary);
  width: 100px !important;
}

.save {
  width: 150px !important;
}

.input {
  margin-top: 10px;
  height: 50px;
  display: inline;
  background-color: var(--secondary);
  padding: 12px;
}

.logo {
  width: 80%;
}

.upload {
  background-color: var(--primary);
  margin-top: 10px;
  line-height: 50px;
  height: 50px;
  padding: 0;
  width: 50px;
}

.actions {
  display: flex;
}

.logoImg, .emptyLogo {
  border: none;
  width: 200px;
  height: 85px;
  object-fit: contain;
}

.colsDef {
  grid-template-columns: 25% 75%;
}

.logo_preview {
  max-height: 153px;
  max-width: 100%;
  object-fit: cover;
}

.classen__rounded_full {
  width: 200px;
  text-align: left;
  padding-left: 40px;
}

.trashLogo {
  height: 50px !important;
  width: 50px !important;
  border-radius: 25px;
}

.load_more_div {
  grid-column: 1  / -1;
}

.buttonWithTooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
}

.buttonWithTooltip .tooltipText {
    visibility: hidden;
    width: 150px;
    background-color: white;
    color: var(--primary);
    text-align: center;
    border: 1px solid var(--primary);
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    bottom: 115%;
    left: 50%;
    margin-left: -75px;
}

.buttonWithTooltip .tooltipText::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: var(--primary) transparent transparent transparent;
}

.buttonWithTooltip:hover .tooltipText {
    visibility: visible;
}

.buttonWithTooltip .tooltipForCloseButton {
    width: 100px !important;
    margin-left: -50px;
}

.labelBeforeSpanClose {
    position: absolute;
    top: 10px;
    left: 13px;
}

.labelBeforeSpanTrash, .labelBeforeSpanList {
    position: absolute;
    top: 10px;
    left: 12px;
}
</style>
